// Ported verbatim from mobile/src/i18n/translations.ts (English + Kurdish Sorani)
export const translations = {
  en: {
    construction: "Construction",
    estimation_system: "Estimation System",
    manage_estimations: "Manage your project estimations",
    sign_in: "Sign In",
    email: "Email",
    password: "Password",
    enter_email: "Enter your email",
    enter_password: "Enter your password",
    enter_email_password: "Please enter email and password",
    login_failed: "Login failed",
    app_version: "Construction Estimation Management v1.0",

    welcome_back: "Welcome back,",
    super_admin: "Super Admin",
    total_units: "Total Units",
    total_estimations: "Estimations",
    recent_estimations: "Recent Estimations",
    no_estimations: "No estimations yet",
    submit_via_units: "Submit estimations via the Units tab",
    unit: "Unit",

    structure: "Structure",
    electrical: "Electrical",
    mechanic: "Mechanic",
    finishing: "Finishing",

    export_report: "Export Report",
    csv: "CSV",
    excel: "Excel",

    site_units: "Site Units",
    units_loaded: "units loaded",
    search_unit: "Search by unit number...",
    no_units_found: "No units found",
    all_types: "All",
    all: "All",
    type_a: "Type A",
    type_b: "Type B",
    type_c: "Type C",

    profile: "Profile",
    role: "Role",
    member_since: "Member Since",
    contractor_phone: "Contractor Phone",
    sign_out: "Sign Out",
    language: "Language",
    english: "English",
    kurdish: "کوردی",
    engineer: "Engineer",

    unit_detail: "Unit Detail",
    block: "Block",
    floor: "Floor",
    submit_new_estimation: "Submit New Estimation",
    estimation_history: "Estimation History",
    total_label: "total",
    first_estimation: "Submit the first estimation for this unit",

    new_estimation: "New Estimation",
    general_info: "General Info",
    materials: "Materials",
    labor: "Labor",
    cost_breakdown: "Cost Breakdown",
    notes: "Notes",
    description: "Description",
    describe_work: "Describe the work...",
    scope_of_work: "Scope of Work",
    define_scope: "Define scope...",
    priority: "Priority",
    high: "High",
    medium: "Medium",
    low: "Low",
    material_list: "Material List",
    list_materials: "List materials needed...",
    est_material_cost: "Est. Material Cost ($)",
    labor_type: "Labor Type",
    labor_type_placeholder: "e.g., Skilled, Unskilled",
    est_labor_hours: "Est. Labor Hours",
    labor_rate: "Labor Rate ($/hr)",
    material_cost: "Material Cost ($)",
    labor_cost: "Labor Cost ($)",
    overhead: "Overhead ($)",
    total_cost: "Total ($)",
    additional_notes: "Additional Notes",
    any_notes: "Any additional notes...",
    submitting_as: "Submitting as:",
    submit_estimation: "Submit Estimation",
    success: "Success",
    estimation_submitted: "Estimation submitted successfully!",
    failed_submit: "Failed to submit",

    estimation_detail: "Estimation Detail",
    estimation_not_found: "Estimation not found",
    delete_estimation: "Delete Estimation",
    confirm_delete: "Confirm Delete",
    confirm_delete_msg: "Are you sure you want to delete this estimation?",
    cancel: "Cancel",
    delete: "Delete",
    failed_delete: "Failed to delete",
    error: "Error",

    electrical_estimation_form: "Electrical Estimation Form",
    top_info: "Estimation Info",
    estimation_number: "Estimation Number",
    date_label: "Date",
    unit_number_label: "Unit Number",
    engineer_name_label: "Engineer Name",
    category_label: "Category",
    electrical_work: "Electrical Work",
    auto_generated: "Auto",
    read_only: "Read Only",
    enter_estimation_number: "Enter estimation number",
    estimation_number_required: "Estimation number is required",
    estimation_number_duplicate: "This estimation number already exists",
    next_expected: "Next expected",
    estimation_number_invalid: "Must be a positive number",
    table_entries: "Work Items",
    rows_label: "rows",
    row_label: "Row",
    work_description: "Work Description",
    percentage: "Percentage (%)",
    unit_price: "Unit Price",
    total_price: "Total Price",
    enter_block: "Enter block...",
    enter_work_desc: "Describe the work...",
    add_row: "Add Row",
    add_row_question: "How would you like to create the new row?",
    add_row_empty: "Empty Row",
    add_row_copy: "Same as Last Row",
    currency: "Currency",
    currency_iqd: "IQD",
    currency_usd: "USD",
    delete_row: "Delete Row",
    totals_section: "Totals",
    subtotal: "Subtotal",
    additional_costs: "Additional Costs",
    final_total: "Final Total",
    file_upload_section: "File Upload",
    upload_estimation_pdf: "Upload Estimation PDF",
    select_pdf: "Tap to select a PDF file",
    pdf_only: "PDF files only (max 10MB)",
    pdf_uploaded: "PDF uploaded successfully",
    upload_failed: "Upload failed",
    add_at_least_one_row: "Please add at least one work item",
    ok: "OK",
    view_pdf: "View PDF",
    estimation_num: "Estimation #",
    rows_count: "Work Items",
    est_rows: "Work Rows",

    mechanic_estimation_form: "Mechanic Estimation Form",
    mechanic_work: "Mechanic Work",
    main_work_type: "Main Work Type",
    sub_work_type: "Sub Work Type",
    select_main_type: "Select work type...",
    select_sub_type: "Select sub type...",
    location: "Location",
    quantity: "Quantity",
    unit_label: "Unit",
    enter_description: "Describe the work...",
    enter_location: "Enter location...",
    enter_unit: "e.g. m, pcs, set",
    select_unit: "Select unit...",
    discount_label: "Discount",

    structure_estimation_form: "Structure Estimation Form",
    structure_work: "Structure Work",
    structure_type: "Structure Type",
    select_structure_type: "Select structure type...",

    electrical_type: "Electrical Type",
    select_electrical_type: "Select electrical type...",

    finishing_estimation_form: "Finishing Estimation Form",
    finishing_work: "Finishing Work",
    finishing_type: "Finishing Type",
    select_finishing_type: "Select finishing type...",
    sub_sub_type: "Sub-Sub Type",
    select_sub_sub_type: "Select detail type...",
    kashi_type: "Kashi Type",
    select_kashi_type: "Select kashi type...",
    boardex_type: "Boardex Type",
    select_boardex_type: "Select boardex type...",

    contractor_name: "Contractor Name",
    enter_contractor_name: "Enter contractor name...",

    select_facility_type: "Select Facility Type",
    facility_type: "Facility Type",

    edit_permission_control: "Edit Permission Control",
    select_engineer: "Select Engineer",
    timer_duration: "Timer Duration (minutes)",
    grant_edit_access: "Grant Edit Access",
    edit_active_until: "Editable until",
    edit_locked: "Locked",
    edit_estimation: "Edit Estimation",
    time_remaining: "Time Remaining",
    edit_expired: "Edit time expired",
    edit_warning: "Less than 1 minute remaining!",
    change_log: "Change Log",
    version: "Version",
    changed_from: "changed from",
    changed_to: "to",
    no_changes: "No changes recorded",
    edit_granted_success: "Edit access granted successfully",
    granting: "Granting...",
    saving_changes: "Saving Changes...",
    cancel_edit: "Cancel Edit",
    save_changes: "Save Changes",
    override_existing: "Override existing edit access?",
    deleted: "Deleted",
    active: "Active",
    restore: "Restore",
    show_deleted: "Show Deleted",
    restored_success: "Estimation restored",
    submit_new_estimation_btn: "Submit New Estimation",
    home_type: "Home Type",
    house_number: "House Number",
    enter_house_number: "Enter house number...",
    ready_to_submit: "Ready to submit",
    duplicate_work_warning: "This work type has already been completed for this unit.",

    preview_estimation: "Preview Estimation",
    generating_preview: "Generating Preview...",
    preview_document: "Preview Document",
    confirm_and_submit: "Confirm & Submit",
    back_to_edit: "Back to Edit",
    preview_note: "Review the document carefully before confirming",
    pdf_generated: "Official PDF document generated",
    generating_pdf: "Generating official document...",
    open_pdf: "Open PDF",
    download_excel: "Download Excel",
    download_pdf: "Download PDF",

    block_number: "Block Number",
    auto_calculated: "Auto-calculated",
    invalid_house_number: "Invalid House Number for the selected Home Type",
    sub_sub_work_type: "Detail Type",
    subject: "Subject",
    enter_subject: "Enter subject...",

    piece_count: "Piece Count",
    brick_quantity: "Quantity",
    total_work: "Total Work",
    current_90: "Current Estimation (90%)",
    current_retention_10: "Current Retention (10%)",
    previous_retention_10: "Previous Retention (10%)",
    final_summary: "Final Summary",
    preview_ready: "Your estimation preview is ready",
    view_document: "View Document",
    estimation_saved: "Estimation saved and official PDF generated!",

    retention: "Retention",
    retention_percentage: "Retention (%)",
    release_date: "Release Date",
    original_price: "Original Price",
    retention_amount: "Retention Amount",
    payable_now: "Payable Now",
    retention_payments: "Retention Payments",
    retention_status: "Status",
    pending: "Pending",
    due: "Due",
    paid: "Paid",
    mark_as_paid: "Mark as Paid",
    payment_date: "Payment Date",

    dashboard: "Dashboard",
    units: "Units",
    back: "Back",
    total_word: "Total",

    // Web-only additions (User Management + nav)
    users: "Users",
    user_management: "User Management",
    settings: "Settings",
    add_user: "Add User",
    create_user: "Create User",
    name: "Name",
    enter_name: "Enter full name...",
    search_users: "Search users...",
    all_roles: "All Roles",
    no_users_found: "No users found",
    user_created: "User created successfully",
    reports: "Reports",
    work_place: "Work Place",
    enter_block_number: "Enter block number",
    enter_phone: "Enter phone number",
    is_required: "is required",
    admin_panel: "Admin Panel",
    view: "View",
    edit: "Edit",
    edit_user: "Edit User",
    reset_password: "Reset Password",
    new_password: "New Password",
    leave_blank_password: "Leave blank to keep current password",
    roles: "Roles",
    select_roles: "Select one or more roles",
    at_least_one_role: "Select at least one role",
    user_updated: "User updated successfully",
    user_deleted: "User deleted",
    delete_user: "Delete User",
    confirm_delete_user: "Are you sure you want to delete this user? Their submitted estimations will be kept.",
    save: "Save",
    user_info: "User Info",
    created_at_label: "Created",
    which_section: "Which section are you working on?",
    ascending: "Ascending",
    descending: "Descending",

    // Mechanic percentage-based progress
    mechanic_pricing: "Mechanic Pricing",
    mechanic_progress_form: "Mechanic Work Progress",
    house_type: "House Type",
    house_progress: "House Progress",
    work_items_label: "Work Items",
    completed_label: "Completed",
    remaining_label: "Remaining",
    available_label: "Available",
    locked_completed: "Already completed",
    base_price_label: "Base Price",
    selected_total: "Selected Total",
    select_work_items: "Select at least one available work item",
    no_available_items: "All work items for this house are completed (100%).",
    loading_house_progress: "Loading house progress...",
    house_complete: "This house is 100% complete.",
    base_price_updated: "Base price updated",
    update_price: "Update Price",
    base_prices_title: "Base Prices (USD)",
    work_items_percentages: "Work Items & Percentages",
    percentage_label: "Percentage",
    price_label: "Price",
    enter_base_price: "Enter base price",
    mechanic_locked_note: "This estimation is locked after submission. To correct it, cancel (delete) and create a new one.",
    enter_house_first: "Enter house type and number to load progress.",
    price_changed_note: "Base price has changed since earlier work; historical amounts are preserved.",
    not_authorized_pricing: "You are not authorized to view mechanic pricing.",
    add_house: "Add House",
    retention_5: "Retention (5%)",
    final_after_retention: "Total after retention",
  },

  ku: {
    construction: "بیناسازی",
    estimation_system: "سیستەمی خەمڵاندن",
    manage_estimations: "بەڕێوەبردنی خەمڵاندنەکانی پرۆژەکەت",
    sign_in: "چوونەژوورەوە",
    email: "ئیمەیڵ",
    password: "وشەی نهێنی",
    enter_email: "ئیمەیڵەکەت بنووسە",
    enter_password: "وشەی نهێنیەکەت بنووسە",
    enter_email_password: "تکایە ئیمەیڵ و وشەی نهێنی بنووسە",
    login_failed: "چوونەژوورەوە سەرنەکەوت",
    app_version: "بەڕێوەبردنی خەمڵاندنی بیناسازی v1.0",

    welcome_back: "بەخێربێیتەوە،",
    super_admin: "بەڕێوەبەری گشتی",
    total_units: "کۆی یەکەکان",
    total_estimations: "خەمڵاندنەکان",
    recent_estimations: "خەمڵاندنە تازەکان",
    no_estimations: "هیچ خەمڵاندنێک نییە تا ئێستا",
    submit_via_units: "خەمڵاندن لە بەشی یەکەکانەوە بنێرە",
    unit: "یەکە",

    structure: "ستراکچەر",
    electrical: "کارەبایی",
    mechanic: "میکانیکی",
    finishing: "فینیشینگ",

    export_report: "هاوردەکردنی ڕاپۆرت",
    csv: "CSV",
    excel: "Excel",

    site_units: "یەکەکانی پرۆژە",
    units_loaded: "یەکە بارکرا",
    search_unit: "گەڕان بە ژمارەی یەکە...",
    no_units_found: "هیچ یەکەیەک نەدۆزرایەوە",
    all_types: "هەموو",
    all: "هەموو",
    type_a: "جۆری A",
    type_b: "جۆری B",
    type_c: "جۆری C",

    profile: "پرۆفایل",
    role: "ڕۆڵ",
    member_since: "ئەندام لە",
    contractor_phone: "ژمارەی مۆبایلی پەیمانکار",
    sign_out: "دەرچوون",
    language: "زمان",
    english: "English",
    kurdish: "کوردی",
    engineer: "ئەندازیار",

    unit_detail: "وردەکاری یەکە",
    block: "بلۆک",
    floor: "نهۆم",
    submit_new_estimation: "ناردنی خەمڵاندنی نوێ",
    estimation_history: "مێژووی خەمڵاندن",
    total_label: "کۆ",
    first_estimation: "یەکەم خەمڵاندن بۆ ئەم یەکەیە بنێرە",

    new_estimation: "خەمڵاندنی نوێ",
    general_info: "زانیاری گشتی",
    materials: "کەرەستەکان",
    labor: "کرێکاری",
    cost_breakdown: "وردەکاری تێچوو",
    notes: "تێبینیەکان",
    description: "وەسف",
    describe_work: "کارەکە وەسف بکە...",
    scope_of_work: "بواری کار",
    define_scope: "بواری کار دیاری بکە...",
    priority: "ئەولەویەت",
    high: "بەرز",
    medium: "ناوەند",
    low: "نزم",
    material_list: "لیستی کەرەستەکان",
    list_materials: "کەرەستە پێویستەکان بنووسە...",
    est_material_cost: "تێچووی خەمڵێنراوی کەرەستە ($)",
    labor_type: "جۆری کرێکاری",
    labor_type_placeholder: "بۆ نموونە: شارەزا، ئاسایی",
    est_labor_hours: "کاتژمێری خەمڵێنراوی کرێکاری",
    labor_rate: "ڕێژەی کرێکاری ($/کاتژمێر)",
    material_cost: "تێچووی کەرەستە ($)",
    labor_cost: "تێچووی کرێکاری ($)",
    overhead: "سەرباری ($)",
    total_cost: "کۆی گشتی ($)",
    additional_notes: "تێبینیەکانی زیادە",
    any_notes: "هەر تێبینیەکی زیادە...",
    submitting_as: "ناردن وەک:",
    submit_estimation: "ناردنی خەمڵاندن",
    success: "سەرکەوتوو",
    estimation_submitted: "خەمڵاندن بە سەرکەوتوویی نێردرا!",
    failed_submit: "ناردن سەرنەکەوت",

    estimation_detail: "وردەکاری خەمڵاندن",
    estimation_not_found: "خەمڵاندن نەدۆزرایەوە",
    delete_estimation: "سڕینەوەی خەمڵاندن",
    confirm_delete: "دڵنیاکردنەوەی سڕینەوە",
    confirm_delete_msg: "دڵنیایت لە سڕینەوەی ئەم خەمڵاندنە؟",
    cancel: "هەڵوەشاندنەوە",
    delete: "سڕینەوە",
    failed_delete: "سڕینەوە سەرنەکەوت",
    error: "هەڵە",

    electrical_estimation_form: "فۆڕمی خەمڵاندنی کارەبایی",
    top_info: "زانیاری خەمڵاندن",
    estimation_number: "ژمارەی خەمڵاندن",
    date_label: "بەروار",
    unit_number_label: "ژمارەی یەکە",
    engineer_name_label: "ناوی ئەندازیار",
    category_label: "پۆل",
    electrical_work: "کاری کارەبایی",
    auto_generated: "خۆکار",
    read_only: "تەنها خوێندن",
    enter_estimation_number: "ژمارەی خەمڵاندن بنووسە",
    estimation_number_required: "ژمارەی خەمڵاندن پێویستە",
    estimation_number_duplicate: "ئەم ژمارەیە پێشتر بەکارهاتووە",
    next_expected: "ژمارەی داواکراوی دواتر",
    estimation_number_invalid: "دەبێت ژمارەیەکی ئەرێنی بێت",
    table_entries: "بابەتەکانی کار",
    rows_label: "ڕیز",
    row_label: "ڕیز",
    work_description: "وەسفی کار",
    percentage: "ڕێژە (%)",
    unit_price: "نرخی یەکە",
    total_price: "نرخی کۆ",
    enter_block: "بلۆک بنووسە...",
    enter_work_desc: "کارەکە وەسف بکە...",
    add_row: "زیادکردنی ڕیز",
    add_row_question: "دەتەوێت ڕیزە نوێیەکە چۆن دروست بکرێت؟",
    add_row_empty: "ڕیزی بەتاڵ",
    add_row_copy: "وەک ڕیزی پێشوو",
    currency: "دراو",
    currency_iqd: "دیناری عێراقی",
    currency_usd: "دۆلاری ئەمریکی",
    delete_row: "سڕینەوەی ڕیز",
    totals_section: "کۆیەکان",
    subtotal: "کۆی ناوەکی",
    additional_costs: "تێچووی زیادە",
    final_total: "کۆی کۆتایی",
    file_upload_section: "بارکردنی فایل",
    upload_estimation_pdf: "بارکردنی PDFی خەمڵاندن",
    select_pdf: "بۆ هەڵبژاردنی فایلی PDF دابگرە",
    pdf_only: "تەنها فایلی PDF (زۆرینە ١٠ مێگابایت)",
    pdf_uploaded: "PDF بە سەرکەوتوویی بارکرا",
    upload_failed: "بارکردن سەرنەکەوت",
    add_at_least_one_row: "تکایە لانیکەم یەک بابەتی کار زیاد بکە",
    ok: "باشە",
    view_pdf: "بینینی PDF",
    estimation_num: "خەمڵاندن #",
    rows_count: "بابەتەکانی کار",
    est_rows: "ڕیزەکانی کار",

    mechanic_estimation_form: "فۆڕمی خەمڵاندنی میکانیک",
    mechanic_work: "کاری میکانیک",
    main_work_type: "جۆری کاری سەرەکی",
    sub_work_type: "جۆری کاری لاوەکی",
    select_main_type: "جۆری کار هەڵبژێرە...",
    select_sub_type: "جۆری لاوەکی هەڵبژێرە...",
    location: "شوێن",
    quantity: "بڕ",
    unit_label: "یەکە",
    enter_description: "کارەکە وەسف بکە...",
    enter_location: "شوێن بنووسە...",
    enter_unit: "بۆ نموونە: م، دانە، سێت",
    select_unit: "یەکە هەڵبژێرە...",
    discount_label: "داشکاندن",

    structure_estimation_form: "فۆڕمی خەمڵاندنی ستراکچەر",
    structure_work: "کاری ستراکچەر",
    structure_type: "جۆری ستراکچەر",
    select_structure_type: "جۆری ستراکچەر هەڵبژێرە...",

    electrical_type: "جۆری کارەبایی",
    select_electrical_type: "جۆری کارەبایی هەڵبژێرە...",

    finishing_estimation_form: "فۆڕمی خەمڵاندنی فینیشینگ",
    finishing_work: "کاری فینیشینگ",
    finishing_type: "جۆری فینیشینگ",
    select_finishing_type: "جۆری فینیشینگ هەڵبژێرە...",
    sub_sub_type: "جۆری وردەکاری",
    select_sub_sub_type: "جۆری وردەکاری هەڵبژێرە...",
    kashi_type: "جۆری کاشی",
    select_kashi_type: "جۆری کاشی هەڵبژێرە...",
    boardex_type: "جۆری بۆردێکس",
    select_boardex_type: "جۆری بۆردێکس هەڵبژێرە...",

    contractor_name: "ناوی مقاول",
    enter_contractor_name: "ناوی مقاول بنووسە...",

    select_facility_type: "جۆری دامەزراوە هەڵبژێرە",
    facility_type: "جۆری دامەزراوە",

    edit_permission_control: "کۆنتڕۆڵی مۆڵەتی دەستکاری",
    select_engineer: "ئەندازیار هەڵبژێرە",
    timer_duration: "ماوەی کاتژمێر (خولەک)",
    grant_edit_access: "مۆڵەتی دەستکاری بدە",
    edit_active_until: "دەستکاری لەبەردەستە تا",
    edit_locked: "داخراوە",
    edit_estimation: "دەستکاری خەمڵاندن",
    time_remaining: "کاتی ماوە",
    edit_expired: "کاتی دەستکاری تەواو بوو",
    edit_warning: "کەمتر لە ١ خولەک ماوە!",
    change_log: "تۆماری گۆڕانکاری",
    version: "وەشان",
    changed_from: "گۆڕدرا لە",
    changed_to: "بۆ",
    no_changes: "هیچ گۆڕانکاریەک تۆمار نەکراوە",
    edit_granted_success: "مۆڵەتی دەستکاری بە سەرکەوتوویی دراو",
    granting: "دەدرێت...",
    saving_changes: "پاشەکەوتکردنی گۆڕانکارییەکان...",
    cancel_edit: "هەڵوەشاندنەوەی دەستکاری",
    save_changes: "پاشەکەوتکردنی گۆڕانکارییەکان",
    override_existing: "مۆڵەتی دەستکاری ئامادەکراو بگۆڕیت؟",
    deleted: "سڕاوەتەوە",
    active: "چالاک",
    restore: "گەڕاندنەوە",
    show_deleted: "سڕاوەکان پیشان بدە",
    restored_success: "خەمڵاندن گەڕێنرایەوە",
    submit_new_estimation_btn: "ناردنی خەمڵاندنی نوێ",
    home_type: "جۆری خانوو",
    house_number: "ژمارەی خانوو",
    enter_house_number: "ژمارەی خانوو بنووسە...",
    ready_to_submit: "ئامادەیە بۆ ناردن",
    duplicate_work_warning: "ئەم جۆرە کارە پێشتر بۆ ئەم یەکەیە خەمڵێندراوە.",

    preview_estimation: "پێشبینینی خەمڵاندن",
    generating_preview: "دروستکردنی پێشبینین...",
    preview_document: "پێشبینینی بەڵگەنامە",
    confirm_and_submit: "دڵنیاکردنەوە و ناردن",
    back_to_edit: "گەڕانەوە بۆ دەستکاری",
    preview_note: "بەڵگەنامەکە بە وریایی پێداچوونەوەی بکە پێش لە دڵنیاکردنەوە",
    pdf_generated: "بەڵگەنامەی فەرمی PDF دروستکرا",
    generating_pdf: "دروستکردنی بەڵگەنامەی فەرمی...",
    open_pdf: "کردنەوەی PDF",
    download_excel: "دابەزینی Excel",
    download_pdf: "دابەزینی PDF",

    block_number: "ژمارەی بلۆک",
    auto_calculated: "بە شێوەی ئۆتۆماتیکی",
    invalid_house_number: "ژمارەی خانوو نادروستە بۆ جۆری خانووی هەڵبژاردکراو",
    sub_sub_work_type: "وردەکاری جۆر",
    subject: "بابەت",
    enter_subject: "بابەت بنووسە...",

    piece_count: "دانە",
    brick_quantity: "چەندێتی",
    total_work: "کۆی کار",
    current_90: "پێشینە ئێستا (90%)",
    current_retention_10: "تەئمینات ڤێلا (10%) پێشینەی ئێستا",
    previous_retention_10: "تەئمینات ڤێلا (10%) پێشینەی پێشوو",
    final_summary: "پوختەی پێشینەی ئێستا",
    preview_ready: "پێشبینینی خەمڵاندنەکەت ئامادەیە",
    view_document: "بینینی بەڵگەنامە",
    estimation_saved: "خەمڵاندن پاشەکەوتکرا و PDFی فەرمی دروستکرا!",

    retention: "ڕاگرتن",
    retention_percentage: "ڕێژەی ڕاگرتن (%)",
    release_date: "بەرواری ئازادکردن",
    original_price: "نرخی ئەسڵی",
    retention_amount: "بڕی ڕاگیراو",
    payable_now: "دراوی ئێستا",
    retention_payments: "پارەدانەکانی ڕاگیراو",
    retention_status: "دۆخ",
    pending: "چاوەڕوانە",
    due: "گەیشتووە",
    paid: "دراوە",
    mark_as_paid: "وەک دراو نیشانبکە",
    payment_date: "بەرواری پارەدان",

    dashboard: "داشبۆرد",
    units: "یەکەکان",
    back: "گەڕانەوە",
    total_word: "کۆی گشتی",

    users: "بەکارهێنەران",
    user_management: "بەڕێوەبردنی بەکارهێنەران",
    settings: "ڕێکخستنەکان",
    add_user: "زیادکردنی بەکارهێنەر",
    create_user: "دروستکردنی بەکارهێنەر",
    name: "ناو",
    enter_name: "ناوی تەواو بنووسە...",
    search_users: "گەڕان بۆ بەکارهێنەران...",
    all_roles: "هەموو ڕۆڵەکان",
    no_users_found: "هیچ بەکارهێنەرێک نەدۆزرایەوە",
    user_created: "بەکارهێنەر بە سەرکەوتوویی دروستکرا",
    reports: "ڕاپۆرتەکان",
    work_place: "شوێنی کار",
    enter_block_number: "ژمارەی بلۆک بنووسە",
    enter_phone: "ژمارەی مۆبایل بنووسە",
    is_required: "پێویستە",
    admin_panel: "پانێڵی بەڕێوەبەر",
    view: "بینین",
    edit: "دەستکاری",
    edit_user: "دەستکاری بەکارهێنەر",
    reset_password: "ڕێستکردنی وشەی نهێنی",
    new_password: "وشەی نهێنی نوێ",
    leave_blank_password: "بەتاڵی بهێڵەرەوە بۆ هێشتنەوەی وشەی نهێنی ئێستا",
    roles: "ڕۆڵەکان",
    select_roles: "یەک یان زیاتر ڕۆڵ هەڵبژێرە",
    at_least_one_role: "لانیکەم یەک ڕۆڵ هەڵبژێرە",
    user_updated: "بەکارهێنەر بە سەرکەوتوویی نوێکرایەوە",
    user_deleted: "بەکارهێنەر سڕایەوە",
    delete_user: "سڕینەوەی بەکارهێنەر",
    confirm_delete_user: "دڵنیایت لە سڕینەوەی ئەم بەکارهێنەرە؟ خەمڵاندنە ناردراوەکانی دەمێننەوە.",
    save: "پاشەکەوتکردن",
    user_info: "زانیاری بەکارهێنەر",
    created_at_label: "دروستکراوە",
    which_section: "لە کام بەشدا کار دەکەیت؟",
    ascending: "بەرزبوونەوە",
    descending: "دابەزین",

    // Mechanic percentage-based progress
    mechanic_pricing: "نرخی میکانیک",
    mechanic_progress_form: "پێشکەوتنی کاری میکانیک",
    house_type: "جۆری خانوو",
    house_progress: "پێشکەوتنی خانوو",
    work_items_label: "کارەکان",
    completed_label: "تەواوبوو",
    remaining_label: "ماوە",
    available_label: "بەردەست",
    locked_completed: "پێشتر تەواوبووە",
    base_price_label: "نرخی بنەڕەتی",
    selected_total: "کۆی هەڵبژێردراو",
    select_work_items: "لانیکەم یەک کاری بەردەست هەڵبژێرە",
    no_available_items: "هەموو کارەکانی ئەم خانووە تەواوبوون (١٠٠٪).",
    loading_house_progress: "بارکردنی پێشکەوتنی خانوو...",
    house_complete: "ئەم خانووە ١٠٠٪ تەواوبووە.",
    base_price_updated: "نرخی بنەڕەتی نوێکرایەوە",
    update_price: "نوێکردنەوەی نرخ",
    base_prices_title: "نرخە بنەڕەتییەکان (USD)",
    work_items_percentages: "کارەکان و ڕێژەکان",
    percentage_label: "ڕێژە",
    price_label: "نرخ",
    enter_base_price: "نرخی بنەڕەتی بنووسە",
    mechanic_locked_note: "ئەم خەمڵاندنە دوای ناردن داخراوە. بۆ چاککردن، بیسڕەوە و یەکی نوێ دروست بکە.",
    enter_house_first: "جۆر و ژمارەی خانوو بنووسە بۆ بارکردنی پێشکەوتن.",
    price_changed_note: "نرخی بنەڕەتی گۆڕاوە لەگەڵ کارە پێشووەکان؛ بڕە مێژووییەکان پارێزراون.",
    not_authorized_pricing: "ڕێگەت پێنەدراوە بۆ بینینی نرخی میکانیک.",
    add_house: "زیادکردنی خانوو",
    retention_5: "لێبڕاو بۆ تەئمینات (٥٪)",
    final_after_retention: "کۆی گشتی دوای لێبڕاو",
  },
};
